import { useContext } from 'react';
import UiAutoLinkText, { type IAutoLinkTextProps } from '@srm/ui/auto-link-text';
import { DocumentRuntimeContext } from '@/context/DocumentRuntimeContext';

// Компонент живёт в @srm/ui; обёртка отключает ссылки в предпросмотре документа для поддержки.
const AutoLinkText: React.FC<IAutoLinkTextProps> = ({ disableLinks, ...props }: IAutoLinkTextProps) => {
    const runtime = useContext(DocumentRuntimeContext);

    return <UiAutoLinkText {...props} disableLinks={disableLinks ?? runtime.mode === 'supportPreview'} />;
};

export default AutoLinkText;
